module.exports = __webpack_public_path__ + "static/media/credit-card.83a740d9.svg";